export class BankModel {
    bankId = 0;
    description = "";
}
